import axios from 'axios'

import config from '../../config.client.js'

const url = config.apiUrl

export default {
  getAvailableFiles: language => {
    return axios.get(`${url}support/available-files/${language}`)
  }
}



// WEBPACK FOOTER //
// ./src/services/support.js